package team.platforma.multiplatform_material_extension.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember


@Composable
internal fun rememberPhoneValidator(): PhoneValidator {
    return remember { PhoneValidator() }
}

internal class PhoneValidator {
    fun createValidatePhoneResult(required: Boolean, phone: String): Boolean {
        return if (required) {
            validatePhone(phone)
        } else {
            if (phone.isNotEmpty()) {
                validatePhone(phone)
            } else {
                true
            }
        }
    }

    private fun validatePhone(phone: String): Boolean {
        when (phone.length) {
            0 -> {
                return false
            }
            1 -> {
                val regex = Regex("^\\+")
                return regex.matches(phone)
            }
            2 -> {
                val regex = Regex("^\\+7")
                return regex.matches(phone)
            }
            else -> {
                val count = phone.length - 2
                val regex = Regex("^\\+7\\d{$count}$")
                return regex.matches(phone)
            }
        }
    }

}